// FE-SCRM-054 — Global-search REST client.

import { api } from "@/api/client";

import type { GlobalSearchResponse } from "./types";


export type { GlobalSearchResponse } from "./types";


export function fetchGlobalSearch(
  q: string,
  opts?: { signal?: AbortSignal; limit?: number },
): Promise<GlobalSearchResponse> {
  const params = new URLSearchParams({ q });
  if (opts?.limit !== undefined) {
    params.set("limit", String(opts.limit));
  }
  return api.get<GlobalSearchResponse>(
    `/api/v1/sales/search?${params.toString()}`,
    { signal: opts?.signal },
  );
}
